import React from "react";
import Box from "@mui/material/Box";
import Paper from "@mui/material/Paper";
import { useTheme, alpha, keyframes } from "@mui/material";

const bounce = keyframes`
  0%, 60%, 100% {
    transform: translateY(0);
  }
  30% {
    transform: translateY(-8px);
  }
`;

export function TypingIndicator() {
    const theme = useTheme();

    return (
        <Box
            sx={{
                alignSelf: 'flex-start',
                maxWidth: '85%',
            }}
        >
            <Paper
                elevation={0}
                sx={{
                    px: 2.5,
                    py: 1.5,
                    borderRadius: '16px 16px 16px 4px',
                    bgcolor: alpha(theme.palette.success.light, 0.15),
                    border: `1px solid ${alpha(theme.palette.success.main, 0.2)}`,
                    display: 'inline-flex',
                    alignItems: 'center',
                    gap: 0.75,
                }}
            >
                {[0, 1, 2].map((index) => (
                    <Box
                        key={index}
                        sx={{
                            width: 8,
                            height: 8,
                            borderRadius: '50%',
                            bgcolor: alpha(theme.palette.success.main, 0.6),
                            animation: `${bounce} 1.4s infinite ease-in-out`,
                            animationDelay: `${index * 0.16}s`,
                        }}
                    />
                ))}
            </Paper>
        </Box>
    );
}
